module.exports = __webpack_public_path__ + "static/media/successOne.859d9e40.mp3";